const WECHAT_USER_INFO_KEY = "wechat_user_profile";
const WECHAT_LOGIN_INFO_KEY = "wechat_login_info";

function parseJSON(value) {
  if (!value) return {};

  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (error) {
    return {};
  }
}

function getSourceObjects(source) {
  if (!source || typeof source !== "object") return [];

  const result = [source];

  if (source.data && typeof source.data === "object") {
    result.push(source.data);
  }

  if (source.user && typeof source.user === "object") {
    result.push(source.user);
  }

  if (source.result && typeof source.result === "object") {
    result.push(source.result);
  }

  return result;
}

function readFirstValue(sources, keys) {
  for (const source of sources) {
    for (const key of keys) {
      if (source[key] !== undefined && source[key] !== null && source[key] !== "") {
        return source[key];
      }
    }
  }

  return "";
}

function normalizeWechatUserProfile(source) {
  const sources = [
    ...getSourceObjects(source),
    ...getSourceObjects(parseJSON(localStorage.getItem(WECHAT_USER_INFO_KEY))),
    ...getSourceObjects(parseJSON(localStorage.getItem(WECHAT_LOGIN_INFO_KEY))),
  ];

  const storedOpenId = localStorage.getItem("openId") || localStorage.getItem("openid") || "";
  const sex = readFirstValue(sources, ["sex", "gender"]);

  return {
    brief: String(readFirstValue(sources, ["brief", "detail", "desc", "description"]) || ""),
    openid: String(readFirstValue(sources, ["openid", "openId"]) || storedOpenId || ""),
    nickName: String(readFirstValue(sources, ["nickName", "nickname", "nick_name"]) || ""),
    sex: sex === "" ? "" : sex,
    headimgurl: String(readFirstValue(sources, ["headimgurl", "headImgUrl", "avatar", "avatarUrl"]) || ""),
  };
}

export function getWechatUserProfile() {
  return normalizeWechatUserProfile();
}

export function persistWechatUserProfile(source) {
  const profile = normalizeWechatUserProfile(source);

  localStorage.setItem(WECHAT_USER_INFO_KEY, JSON.stringify(profile));

  if (profile.openid) {
    localStorage.setItem("openId", profile.openid);
    localStorage.setItem("openid", profile.openid);
  }

  return profile;
}
